import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function FooterSection({ onRequestInvite }) {
  return (
    <footer data-testid="footer-section" className="relative overflow-hidden bg-[#171412] text-[#FAF6F0]">
      <div className="mx-auto max-w-[1600px] px-6 pb-10 pt-24 sm:px-12 lg:px-20">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-6">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#C59B27]">
              Status — Polishing the brass
            </p>
            <h2 className="mt-4 font-serif text-4xl tracking-tight sm:text-5xl">
              The doors open<br />
              <span className="italic text-[#C59B27]">this autumn.</span>
            </h2>
            <button
              data-testid="footer-invite-btn"
              onClick={onRequestInvite}
              className="group mt-8 flex items-center gap-2 border border-[#C59B27] px-6 py-3.5 font-mono text-[11px] uppercase tracking-[0.25em] text-[#C59B27] transition-colors duration-300 hover:bg-[#C59B27] hover:text-[#171412]"
            >
              Request Collector Invite
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </div>

          <div className="col-span-12 flex flex-col justify-end gap-6 lg:col-span-6 lg:items-end">
            <a
              data-testid="footer-seller-inquiry-link"
              href="mailto:sellers@oldengoods.example"
              className="group flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-[#FAF6F0]/70 transition-colors duration-300 hover:text-[#C59B27]"
            >
              Selling vintage? Apply to the ledger
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <p className="max-w-xs text-sm leading-relaxed text-[#FAF6F0]/50 lg:text-right">
              Authenticated clothing, decor, and collectibles from vetted sellers.
              Every piece has a past — we make sure it's an honest one.
            </p>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-[#2E2824] pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright" className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#FAF6F0]/40">
            © 2026 OldenGoods — Under Construction
          </p>
          <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-[#FAF6F0]/40">
            <span className="animate-status h-1.5 w-1.5 rounded-full bg-[#C59B27]" />
            Systems nominal — vault at 73%
          </div>
        </div>
      </div>

      <motion.div
        data-testid="footer-logo-watermark"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
        className="pointer-events-none select-none whitespace-nowrap text-center font-serif text-[13.5vw] leading-[0.8] tracking-tight text-[#FAF6F0]/[0.05]"
        aria-hidden="true"
      >
        OLDENGOODS
      </motion.div>
    </footer>
  );
}
